// extracted by mini-css-extract-plugin
module.exports = {"addPatientPaper":"styles_addPatientPaper__1o9mA","passField":"styles_passField__2WgA7"};